export default __webpack_public_path__ + "static/media/wall.daa11de1.png";